import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Building2Icon, Globe2Icon, CalendarDaysIcon, UsersIcon, SparklesIcon, ArrowRightIcon, HeartPulseIcon } from 'lucide-react';
const audiences = [{
  title: 'Hotels & Resorts',
  desc: 'Win group business with premium experiences.',
  icon: Building2Icon,
  path: '/for-hotels',
  color: 'text-brand-teal',
  bg: 'bg-brand-teal/10',
  hoverBorder: 'hover:border-brand-teal/30'
}, {
  title: 'Health Clubs & Spas',
  desc: 'Turn members into corporate group clients.',
  icon: HeartPulseIcon,
  path: '/for-health-clubs',
  color: 'text-rose-500',
  bg: 'bg-rose-100',
  hoverBorder: 'hover:border-rose-300'
}, {
  title: 'DMCs',
  desc: 'Stand out from generic destination management.',
  icon: Globe2Icon,
  path: '/for-dmcs',
  color: 'text-brand-coral',
  bg: 'bg-brand-coral/10',
  hoverBorder: 'hover:border-brand-coral/30'
}, {
  title: 'MICE Planners',
  desc: 'Deliver measurable ROI for corporate clients.',
  icon: CalendarDaysIcon,
  path: '/for-mice',
  color: 'text-brand-navy',
  bg: 'bg-brand-navy/10',
  hoverBorder: 'hover:border-brand-navy/30'
}, {
  title: 'HR & People',
  desc: 'Build culture that lasts beyond the retreat.',
  icon: UsersIcon,
  path: '/for-hr',
  color: 'text-amber-600',
  bg: 'bg-amber-100',
  hoverBorder: 'hover:border-amber-300'
}, {
  title: 'Facilitators',
  desc: 'Scale your impact and license your frameworks.',
  icon: SparklesIcon,
  path: '/for-facilitators',
  color: 'text-purple-600',
  bg: 'bg-purple-100',
  hoverBorder: 'hover:border-purple-300'
}];
export function AudienceSelector() {
  return <section className="py-24 px-6 md:px-10 bg-white relative overflow-hidden" data-id="element-201">
      <div className="max-w-7xl mx-auto" data-id="element-202">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-203">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-204">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4 tracking-tight" data-id="element-205">
              Built for every kind of organizer
            </h2>
            <p className="text-lg text-slate-600" data-id="element-206">
              Whether you're selling the destination, planning the logistics, or
              delivering the content—Offsite+ is your competitive advantage.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-207">
          {audiences.map((aud, i) => {
          const Icon = aud.icon;
          return <motion.div key={aud.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1,
            duration: 0.5
          }} data-id="element-208">
                <Link to={aud.path} className={`group block h-full bg-white rounded-2xl border border-slate-200 p-6 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 ${aud.hoverBorder}`} data-id="element-209">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 transition-transform group-hover:scale-110 duration-300 ${aud.bg} ${aud.color}`} data-id="element-210">
                    <Icon className="w-6 h-6" data-id="element-211" />
                  </div>
                  <h3 className="text-lg font-bold text-brand-navy mb-2 group-hover:text-brand-teal transition-colors" data-id="element-212">
                    {aud.title}
                  </h3>
                  <p className="text-sm text-slate-500 mb-6 leading-relaxed" data-id="element-213">
                    {aud.desc}
                  </p>
                  <div className="mt-auto flex items-center text-sm font-semibold text-brand-navy group-hover:text-brand-teal transition-colors" data-id="element-214">
                    Learn more
                    <ArrowRightIcon className="w-4 h-4 ml-1.5 transition-transform group-hover:translate-x-1" data-id="element-215" />
                  </div>
                </Link>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}